/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import Loader from '../../../loader';
import WarningBox from './warning-box';
import { processPageLink } from '../../../../utils/url-utils';

import LocalizationConsumer from '../../../../l10n/localization-context';

class SitePageTab extends React.Component
{
  static propTypes = {
    url: PropTypes.string.isRequired,
    onComponentMount: PropTypes.func.isRequired,
    onSiteLinkClick: PropTypes.func.isRequired,
    sitePageData: PropTypes.shape(),
    isSitePageDataLoading: PropTypes.bool.isRequired,
    isSitePageDataLoadingError: PropTypes.bool.isRequired,
    isSlideShowInsertLinksMode: PropTypes.bool.isRequired
  };

  static defaultProps = {
    sitePageData: null
  };

  state = {
    selectedPageId: null,
    isAdminOnlyPageSelected: false,
    isLimitedPageSelected: false
  };


  componentDidMount()
  {
    this.props.onComponentMount();
  }

  onLinkClick = (item) =>
  {
    const { onSiteLinkClick } = this.props;

    const { id, accessControl } = item;
    const { adminOnly, limited } = accessControl.permissions;

    this.setState({
      selectedPageId: id,
      isAdminOnlyPageSelected: adminOnly,
      isLimitedPageSelected: limited
    });

    onSiteLinkClick(item);
  };

  renderItem = (item) =>
  {
    const {
      id,
      name,
      children,
      accessControl,
      url: itemUrl
    } = item;

    const { url: propsUrl } = this.props;

    const { adminOnly, limited } = accessControl.permissions;

    const { selectedPageId } = this.state;

    const accessControlIconClassName = classnames({
      '-wa-edit-controls__pages-structure-link-access-control': true,
      '-wa-edit-controls__pages-structure-link-access-control__admin-only': adminOnly,
      '-wa-edit-controls__pages-structure-link-access-control__limited': limited
    });

    const accessControlLinkClassName = classnames({
      '-wa-edit-controls__pages-structure-link': true,
      '-wa-edit-controls__pages-structure-link__selected': id === selectedPageId || propsUrl === processPageLink(itemUrl)
    });

    return (
      <li className="-wa-edit-controls__pages-structure-item" key={id}>
        <a className={accessControlLinkClassName} href="#" onClick={() => this.onLinkClick(item)}>
          <span className="-wa-edit-controls__pages-structure-link-title" title={name}>{name}</span>
          <div className={accessControlIconClassName} />
        </a>
        {children.length ? this.renderPages(children) : null}
      </li>
    );
  };

  renderPages = (data) =>
  {
    if (!data.length) return null;

    return (
      <ul className="-wa-edit-controls__pages-structure-list">
        {data.map(item => this.renderItem(item))}
      </ul>
    );
  };

  renderContent = (data) =>
  {
    const { menuPages, notInMenuPages } = data;
    const { isSlideShowInsertLinksMode } = this.props;
    const { isAdminOnlyPageSelected, isLimitedPageSelected } = this.state;


    const getPageStructureHeight = () =>
    {
      const isAdminOnlyOrLimited = isAdminOnlyPageSelected || isLimitedPageSelected;

      if (isSlideShowInsertLinksMode)
      {
        return isAdminOnlyOrLimited ? '222px' : '265px';
      }
      return isAdminOnlyOrLimited ? '392px' : '435px';
    };

    const getWarning = () =>
    {
      if (isAdminOnlyPageSelected)
      {
        return <LocalizationConsumer id="insert-link-dialog.site-page-tab.admin-only-page-warning" />;
      }
      if (isLimitedPageSelected)
      {
        return <LocalizationConsumer id="insert-link-dialog.site-page-tab.restricted-page-warning" />;
      }
      return null;
    };

    return (
      <div className="-wa-edit-controls__pages-tab">
        <div className="-wa-edit-controls__pages-structure" style={{ height: getPageStructureHeight() }}>
          {menuPages.length ? (
            <div className="-wa-edit-controls__pages-structure-header">
              <LocalizationConsumer id="insert-link-dialog.site-page-tab.menu-pages" />
            </div>) : null}
          {this.renderPages(menuPages)}
          {notInMenuPages.length ? (
            <div className="-wa-edit-controls__pages-structure-header">
              <LocalizationConsumer id="insert-link-dialog.site-page-tab.not-in-menu-pages" />
            </div>) : null}
          {this.renderPages(notInMenuPages)}
        </div>
        <WarningBox>
          {getWarning()}
        </WarningBox>
      </div>
    );
  };

  render()
  {
    const { sitePageData, isSitePageDataLoading, isSitePageDataLoadingError } = this.props;

    if (isSitePageDataLoading)
    {
      return <Loader />;
    }

    if (isSitePageDataLoadingError || !sitePageData)
    {
      return (
        <div>
          <LocalizationConsumer id="insert-link-dialog.site-page-tab.load-error" />;
        </div>);
    }

    return this.renderContent(sitePageData);
  }
}

export default SitePageTab;